import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { Asignacion } from '../shared/models/asignacion';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-liberar-ip',
  templateUrl: './liberar-ip.component.html',
  styleUrls: ['./liberar-ip.component.css']
})
export class LiberarIpComponent implements OnInit {

  MINIMO_CARCTERES_URL = 6;
  MINIMO_CARCTERES_SERVIDOR = 8;
  MINIMO_CARACTERES_USUARIO = 8;
  MENSAJE_MAXIMO_IP_LIBERAR = 'No puede liberar mas de 10 direcciones ip';
  MENSAJE_MINIMO_URL = 'Debe digitar al menos ' + this.MINIMO_CARCTERES_URL.toString() + ' caracteres de la URL';
  MENSAJE_MINIMO_SERVIDOR = 'Debe digitar al menos ' + this.MINIMO_CARCTERES_SERVIDOR.toString() + ' caracteres para el servidor';
  MENSAJE_MINIMO_USUARIO = 'Debe digitar al menos ' + this.MINIMO_CARACTERES_USUARIO.toString() + ' caracteres para el usuario';


  direccionIp = '';
  url = '';
  servidor = '' ;
  usuario = '';
  ipSeleccionada: string;
  urlseleccionada: string;
  servidorSeleccionado: string;
  usuarioSeleccionado: string;
  asignaciones: Asignacion[] = new Array<Asignacion>();
  indFiltros = false;
  contador = 0;
  asignacionesLiberadas: Asignacion[] = new Array<Asignacion>();
  modalRef: NgbModalRef;
  IP_PERMITIDAS: number = environment.miximoIpLiberar;
  mensajeAlerta: string;
  error;



  constructor(private administradorService: AdministradorIpService,
  private modalService: NgbModal) { }

  ngOnInit() {
  }

  // Este metodo se ejecuta cada vez que se marca una asignacion para liberarDiercciones
  // valida que no se hayan seleccionado mas direcciones que las permitidas.
  onChangeLiberarOption(alertaModal) {
    this.contador = 0;
    for (const asignacion of this.asignaciones) {
      if (asignacion.direccionIp.indicadorDisponible == true) {
        this.contador = this.contador + 1;
      }
    }
    if (this.contador > this.IP_PERMITIDAS) {
      this.mensajeAlerta = this.MENSAJE_MAXIMO_IP_LIBERAR;
      this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
    }
  }

  // Metodo que carga la lista de direcciones asignadas
  public listarAsignaciones(cargandoModal): void {
    this.asignaciones = new Array<Asignacion>();
    this.contador = 0;
    this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false});
    this.administradorService.buscarAsignacionesParaLiberar(this.ipSeleccionada, this.urlseleccionada,
      this.servidorSeleccionado, this.usuarioSeleccionado).subscribe(
        resultado => {
          this.asignaciones = resultado;
          this.modalRef.close();
      }
      );
  }

  // Se validan los filtros de busqueda y se asigna valor a los campos vacios
  public validarFiltros(cargandoModal, alertaModal): void {
    this.indFiltros = false;
    this.asignaciones = new Array<Asignacion>();
    if (this.url.trim().length == 0) {
      this.urlseleccionada = '-1';
    } else {
      if (this.url.trim().length < this.MINIMO_CARCTERES_URL) {
        this.mensajeAlerta = this.MENSAJE_MINIMO_URL;
        this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
        return;
      }
      this.urlseleccionada = this.url.toUpperCase();
      this.indFiltros = true;
    }
    if (this.direccionIp.trim().length == 0) {
      this.ipSeleccionada = '-1';
    } else {
      this.indFiltros = true;
      this.ipSeleccionada = this.direccionIp.toUpperCase();
    }
    if (this.servidor.trim().length == 0) {
      this.servidorSeleccionado = '-1';
    } else {
      if (this.servidor.trim().length < this.MINIMO_CARCTERES_SERVIDOR) {
        this.mensajeAlerta = this.MENSAJE_MINIMO_SERVIDOR;
        this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
        return;
      }
      this.servidorSeleccionado = this.servidor.toUpperCase();
      this.indFiltros = true;
    }
    if (this.usuario.trim().length == 0) {
      this.usuarioSeleccionado = '-1';
    } else {
      if (this.usuario.trim().length < this.MINIMO_CARACTERES_USUARIO) {
        this.mensajeAlerta = this.MENSAJE_MINIMO_USUARIO;
        this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
        return;
      }
      this.usuarioSeleccionado = this.usuario.toUpperCase();
      this.indFiltros = true;
    }
    if (this.indFiltros == true) {
      this.listarAsignaciones(cargandoModal);
    }
  }

  // Metodo que envia las asignaciones seleccionadas al back para liberar las ip
  public liberarDirecciones(resultadoModal, cargandoModal): void {
    this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
    const asignacionesALiberar: Asignacion[] = new Array<Asignacion>();
    this.asignacionesLiberadas = new Array<Asignacion>();
    // se recorre la lista de asignaciones y se crea lista con las asignaciones
    // marcadas para liberar
    for (const asignacion of this.asignaciones) {
      if (asignacion.direccionIp.indicadorDisponible == true) {
        asignacionesALiberar.push(asignacion);
      }
    }
    if (asignacionesALiberar.length >= 1) {
      this.administradorService.liberarDiercciones(asignacionesALiberar).subscribe(
        resultado => {
          this.asignacionesLiberadas = resultado;
          if (this.asignacionesLiberadas.length >= 1) {
            this.modalRef.close();
            this.modalRef = this.modalService.open(resultadoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
          }
        }, error => {
          this.error = error;
          this.modalRef.close();
        }
      );
    }
  }

  // se reinicia los parametros.
  public ocultarModalResultado(): void {
    this.direccionIp = '';
    this.url = '';
    this.servidor = '';
    this.usuario = '';
    this.ipSeleccionada = '';
    this.urlseleccionada = '';
    this.servidorSeleccionado = '';
    this.usuarioSeleccionado = '';
    this.asignaciones = new Array<Asignacion>();
    this.indFiltros = false;
    this.contador = 0;
    this.asignacionesLiberadas = new Array<Asignacion>();
    this.modalRef.close();
  }

  validarIP(ip): boolean {
    let contador = 0;
    for (let index = 0; index < ip.length(); index++) {
      if (ip[index] == '.') {
        contador = contador + 1;
      }
    }
    if (contador == 3) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/liberar-ip/liberar-ip.component.ts